/* Katana UX fixes 2026-10-06 (see notes/ux-audit/ux-audit-2026-10-06.md). Loaded sitewide from sections/header-group.json.
   1. Variant picker: picking a Size snaps Bolt Pattern / Offset to a combination that exists (prefers in stock),
      and hides Bolt Pattern / Offset values that don't exist for the sizes chosen above them.
   2. Product page: "Set of 4" price, low-stock note when fewer than 4 are left, mobile sticky add-to-cart bar.
   3. Product cards: mark sold-out cards, add "Price per wheel" under wheel prices.
   4. Cart page: per-wheel hint on wheel lines with quantity under 4. */
(function () {
  'use strict';

  var WHEEL_URL = /\/products\/(hr|kr)\d/i;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function money(cents) { return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------------- 1. Variant picker ---------------- */
  function vData(vr) {
    if (!vr._kxData) {
      var s = vr.querySelector('script[type="application/json"]');
      try { vr._kxData = s ? JSON.parse(s.textContent) : []; } catch (e) { vr._kxData = []; }
    }
    return vr._kxData;
  }
  function vSets(vr) { return Array.prototype.slice.call(vr.querySelectorAll('fieldset')); }
  function vSel(vr) { return vSets(vr).map(function (fs) { var r = fs.querySelector('input:checked'); return r ? r.value : null; }); }
  function findInput(fs, value) {
    var ins = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < ins.length; i++) { if (ins[i].value === value) return ins[i]; }
    return null;
  }
  function currentVariant(vr) {
    if (!vr) return null;
    var sel = vSel(vr), data = vData(vr);
    for (var i = 0; i < data.length; i++) {
      if (data[i].options.every(function (o, j) { return o === sel[j]; })) return data[i];
    }
    return null;
  }
  function hideMissing(vr) {
    var data = vData(vr), sets = vSets(vr), sel = vSel(vr);
    sets.forEach(function (fs, i) {
      if (i === 0) return;
      each(fs.querySelectorAll('input[type="radio"]'), function (r) {
        var exists = data.some(function (v) {
          for (var j = 0; j < i; j++) { if (v.options[j] !== sel[j]) return false; }
          return v.options[i] === r.value;
        });
        r.hidden = !exists;
        var lab = fs.querySelector('label[for="' + r.id + '"]');
        if (lab) lab.hidden = !exists;
      });
    });
  }

  // Capture phase: runs before Dawn's VariantRadios change handler, so Dawn sees a valid combination.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.closest) return;
    var vr = input.closest('variant-radios');
    if (!vr) return;
    var data = vData(vr);
    if (!data.length) return;
    var sets = vSets(vr), idx = sets.indexOf(input.closest('fieldset')), sel = vSel(vr);
    if (idx < 0) return;
    if (!currentVariant(vr)) {
      var best = null, bestScore = -1;
      data.forEach(function (v) {
        if (v.options[idx] !== sel[idx]) return;
        var s = v.available ? 50 : 0;
        for (var i = 0; i < sel.length; i++) { if (i !== idx && v.options[i] === sel[i]) s += (i < idx ? 100 : 10); }
        if (s > bestScore) { best = v; bestScore = s; }
      });
      if (best) {
        best.options.forEach(function (o, i) {
          if (i === idx) return;
          var r = findInput(sets[i], o);
          if (r) r.checked = true;
        });
      }
    }
    setTimeout(function () { hideMissing(vr); }, 0);
  }, true);

  /* ---------------- 2. Product page ---------------- */
  function productPage() {
    var info = document.querySelector('product-info, .product__info-container');
    if (!info) return;
    var vr = info.querySelector('variant-radios') || document.querySelector('variant-radios');
    if (vr) hideMissing(vr);

    // Set-of-4 price
    var per = document.querySelector('.kx-perwheel [data-kx-set]');
    function updateSet() {
      var v = currentVariant(vr);
      if (per && v) per.textContent = 'Set of 4: ' + money(v.price * 4);
    }

    // Low-stock note (inventory block shows "Low stock: N left" at or under the threshold)
    var inv = document.querySelector('[id^="Inventory-"]');
    function updateStock() {
      if (!inv) return;
      var note = document.getElementById('kx-stocknote');
      var m = (inv.textContent || '').match(/(\d+)\s+left/i);
      var n = m ? parseInt(m[1], 10) : null;
      if (n !== null && n < 4 && !inv.classList.contains('visibility-hidden')) {
        if (!note) {
          note = document.createElement('p');
          note.id = 'kx-stocknote';
          note.className = 'kx-stocknote';
          inv.insertAdjacentElement('afterend', note);
        }
        note.innerHTML = 'Only ' + n + ' left in this size, and most cars need 4. <a href="/pages/contact">Ask about restock timing</a>.';
      } else if (note) {
        note.parentNode.removeChild(note);
      }
    }
    if (inv) new MutationObserver(updateStock).observe(inv, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-radios')) setTimeout(updateSet, 0);
    });
    updateSet();
    updateStock();

    var btn = info.querySelector('.product-form__submit');
    if (btn && 'IntersectionObserver' in window) stickyBar(btn, vr);
  }

  function stickyBar(btn, vr) {
    var titleEl = document.querySelector('.product__title h1');
    var bar = document.createElement('div');
    bar.className = 'kx-sticky';
    bar.innerHTML = '<div class="kx-sticky__info"><span class="kx-sticky__title"></span><span class="kx-sticky__meta"></span></div>' +
      '<button type="button" class="button button--primary kx-sticky__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);
    document.body.classList.add('kx-has-sticky');
    bar.querySelector('.kx-sticky__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    var meta = bar.querySelector('.kx-sticky__meta');
    var sbtn = bar.querySelector('.kx-sticky__btn');
    var below = true; // real button is further down the page

    function refresh() {
      var v = currentVariant(vr);
      meta.textContent = v ? v.public_title.replace(/ \/ /g, ' · ') + ' · ' + money(v.price) + ' / wheel' : 'Choose a size';
      if (below) { sbtn.textContent = 'Choose size'; sbtn.disabled = false; }
      else { sbtn.textContent = (btn.textContent || '').trim() || 'Add to cart'; sbtn.disabled = btn.disabled; }
    }
    sbtn.addEventListener('click', function () {
      if (below || btn.disabled) { (vr || btn).scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      btn.click();
    });
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      below = !en.isIntersecting && en.boundingClientRect.top > 0;
      bar.classList.toggle('is-visible', !en.isIntersecting);
      sbtn.tabIndex = en.isIntersecting ? -1 : 0;
      refresh();
    }).observe(btn);
    new MutationObserver(refresh).observe(btn, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('change', function () { setTimeout(refresh, 0); });
    refresh();
  }

  /* ---------------- 3. Product cards ---------------- */
  function cards() {
    each(document.querySelectorAll('.card-wrapper:not([data-kx])'), function (w) {
      w.setAttribute('data-kx', '1');
      var badge = w.querySelector('.card__badge .badge');
      if (badge && /sold out/i.test(badge.textContent)) w.classList.add('kx-soldout');
      var link = w.querySelector('a[href*="/products/"]');
      var price = w.querySelector('.price');
      if (link && price && WHEEL_URL.test(link.getAttribute('href'))) {
        var s = document.createElement('span');
        s.className = 'kx-per';
        s.textContent = 'Price per wheel';
        price.insertAdjacentElement('afterend', s);
      }
    });
  }

  /* ---------------- 4. Cart page ---------------- */
  var cartBusy = false;
  function cartHints() {
    var rows = document.querySelectorAll('cart-items .cart-item');
    if (!rows.length || cartBusy) return;
    var todo = false;
    each(rows, function (r) { if (!r.hasAttribute('data-kx')) todo = true; });
    if (!todo) return;
    cartBusy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        each(document.querySelectorAll('cart-items .cart-item'), function (row) {
          row.setAttribute('data-kx', '1');
          var i = parseInt((row.id || '').replace('CartItem-', ''), 10) - 1;
          var item = cart.items[i];
          var old = row.querySelector('.kx-cart-hint');
          if (old) old.parentNode.removeChild(old);
          if (item && item.product_type === 'Wheels' && item.quantity < 4) {
            var p = document.createElement('p');
            p.className = 'kx-cart-hint';
            p.textContent = 'Prices are per wheel. You have ' + item.quantity + ' of 4 for a full set.';
            (row.querySelector('.cart-item__details') || row).appendChild(p);
          }
        });
      })
      .catch(function () {})
      .then(function () { cartBusy = false; });
  }

  /* ---------------- boot ---------------- */
  ready(function () {
    productPage();
    cards();
    cartHints();
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { cards(); cartHints(); }, 150);
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  });
})();
